<template>
 <!-- 货物详情 -->
  <el-dialog  title="货物详情"  :visible.sync="detailDialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div>
        <el-table
          height="200px"
          size="mini"
          ref="tabref"
          :data="goodList"
          style="width:100%"
          class="elTab"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" :formatter="emptyFn"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" :formatter="emptyFn" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="brand" label="牌号" :formatter="emptyFn" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" :formatter="emptyFn" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" :formatter="emptyFn" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" :formatter="emptyFn" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="position" label="库位" align="center" :formatter="emptyFn"></el-table-column>
        </el-table>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">取 消</el-button>
      </span>
   </el-dialog>

</template>

<script>
import { getGoodListByDisId } from '@/api/consignment'
import { emptyFn } from '@/utils/util'
export default {
  name: 'lookGoodsDetails',
  props: {
    rowDataList: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      detailDialog: false,
      goodList: [],
      emptyFn: emptyFn
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowDataList) {
      this.detailDialog = true
      getGoodListByDisId({
        distributionId: this.rowDataList.distributionId,
        distributionType: this.rowDataList.distributionType,
        wayType: this.rowDataList.wayType,
        isSync: this.rowDataList.isSync
      }).then(res => {
        this.goodList = res
      })
      // .catch(err => {
      //   this.$message.error(err.message)
      // })
    }
  },
  methods: {
    closeDialog () {
      this.$emit('detailDestroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
// .hidden /deep/.el-upload--picture-card{
//   display: none;
// }
// /deep/.el-form--inline .diqu .el-form-item__content{
//       flex-direction: row;
// }
// /deep/.el-image {
//   margin: 10px;
// }
</style>
